// extracted by mini-css-extract-plugin
module.exports = {"product__edit":"ProductEditScreen_product__edit__22s-F","form":"ProductEditScreen_form__3dt0l"};